import React, { useEffect, useState } from "react";
// 1. Import Helmet
import { Helmet } from "react-helmet"; 
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";

// Define metadata constants for SEO
const PAGE_TITLE = "Maritime Legal Assistance & Insights | Steminorder Blog";
const PAGE_DESCRIPTION = "Access expert legal articles, industry trends, and maritime law updates from Steminorder. Find comprehensive legal assistance tips for shipping professionals.";
const CANONICAL_URL = "https://www.steminorder.com/legal";
const OG_IMAGE_URL = "https://www.steminorder.com/images/legal-hero-pattern.png"; // Use a relevant image for sharing

const LegalPage = () => {
  const navigation = useNavigate();
  const [blogCategories, setBlogCategories] = useState([]);
  const [blogList, setBlogList] = useState([]);
  useEffect(() => {
    fetch("https://services.steminorder.com/admin/websitedata", {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        console.log(data["bloglist"]);
        setBlogCategories(data["blogCategories"]);
        setBlogList(data["bloglist"]);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  const redirectToDetail = (pageslug) => {
    console.log("clicked", pageslug);
    navigation("/legal-detail?s=" + pageslug);
  };

  return (
    <>
      {/* ============================================================
        REACT HELMET INTEGRATION 
        ============================================================
      */}
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        
        {/* Canonical URL */}
        <link rel="canonical" href={CANONICAL_URL} />

        {/* Open Graph Tags */}
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={CANONICAL_URL} />
        <meta property="og:type" content="blog" /> {/* Changed type to 'blog' or 'article' */}
        <meta property="og:site_name" content="Steminorder" />
        <meta property="og:image" content={OG_IMAGE_URL} /> 
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <meta name="twitter:image" content={OG_IMAGE_URL} />
      </Helmet>
      
      <Header />

      <div className="bg-legal-hero-pattern bg-center">
        <div className="container text-white p-5">
          <div className="row d-flex justify-center text-center">
            <div className="col-lg-5 col-sm-12">
              <h1 className="font-bold text-4xl text-center">
                Legal Assistance Tips
              </h1>
              <div className="input-group my-5">
                <div className="input-group-prepend border-none">
                  <span
                    className="input-group-text border-none"
                    id="basic-addon1"
                  >
                    <i className="bi bi-search"></i>
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control legal-search-input shadow-none"
                  placeholder="Search"
                  aria-label="Search"
                  aria-describedby="basic-addon1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row py-5">
          <div className="col-lg-3 offset-lg-3 col-sm-6">
            <select
              className="form-select border-solid"
              aria-label="Default select example"
            >
              <option>Sort By Date</option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </select>
          </div>
          <div className="col-lg-3 offset-lg-3 col-sm-6 mt-sm-4">
            <select
              className="form-select border-solid"
              aria-label="Default select example"
            >
              <option>All Category</option>
              {blogCategories.map((category) => (
                <option value={category.id}>{category.value}</option>
              ))}
            </select>
          </div>
        </div>
        <section className="main-body">
          {blogList.map((blog) => (
            <div
              className="row line pb-5 pe-auto"
              onClick={() => redirectToDetail(blog.pageslug)}
            >
              <div className="col-lg-3 col-sm-12">
                <img
                  className="img img-responsive rounded-4"
                  src={blog.imagename}
                  alt=""
                />
              </div>
              <div className="col-9">
                <div className="row pt-4">
                  <div className="col-10">
                    <h5 className="text-uppercase text-sm text-breadcrumb">
                      {blog.blogcategory}
                    </h5>
                  </div>
                  <div className="col-2">
                    <span className="text-right text-sm text-breadcrumb">
                      {blog.blogdate}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <h2 className="py-3 text-3xl text-heading font-bold">
                    {blog.title}
                  </h2>
                  <p className="text-paragraph text-sm">
                    {blog.shortdescription}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </section>
      </div>
      <Footer />
    </>
  );
};

export default LegalPage;